import { render, staticRenderFns } from "./DocumentDialog.vue?vue&type=template&id=1eff1295&scoped=true"
import script from "./DocumentDialog.vue?vue&type=script&lang=js"
export * from "./DocumentDialog.vue?vue&type=script&lang=js"
import style0 from "./DocumentDialog.vue?vue&type=style&index=0&id=1eff1295&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eff1295",
  null
  
)

export default component.exports